module.exports = __webpack_public_path__ + "img/JoeWahba_O_38.4dda8695.jpg";